var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Delivery Payouts"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('MonthSelector',{on:{"select":_vm.load}})]},proxy:true}])},[_c('List')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }